import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pan-share-web" }
const _hoisted_2 = { class: "pan-share-web-content" }
const _hoisted_3 = { class: "banner-wrap" }
const _hoisted_4 = { class: "login-web" }
const _hoisted_5 = {
  class: "login-wrap",
  id: "login-wrap"
}

import { onMounted, computed, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useEnvStore } from '@remote/store/env'
import { isSeparateAccount } from '@remote/api/config'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import loginIframeFunc from '@/utils/login-iframe'
import Carousel from './components/Carousel.vue'
import Login from './components/Login.vue'
// import sso, { getSSOUser } from '@remote/utils/sso'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const envStore = useEnvStore()
const router = useRouter()
const route = useRoute()
let timer
let isInit = false
const isLogin = computed(() => {
  return store.getters.isLogin
})

const loopLogin = async () => {
  const isLogin = await store.dispatch('login')
  if (!isLogin) {
    timer = setTimeout(loopLogin, 3000)
  }
}

watch(isLogin, (val) => {
  console.log('watch', val)
  if (val) {
    router.replace({
      path: '/home',
      query: route.query,
    })
    timer = setTimeout(loopLogin, 3000)
  }
})

const goAuth = () => {
  router.push({
    path: '/authorize',
    query: route.query,
  })
}

const login = async () => {
  // 正常的登录流程
  const isLogin = await store.dispatch('login', { forceLogin: 1 })
  if (isLogin) {
    if (route.query.authorize && route.query.authorize === 'signin') {
      goAuth()
    }
  }
}

onMounted(() => {
  if (envStore.isInPC) {
    window.native.CallNativeFunction('GetUserID', async (status: number, userID: string) => {
      console.log('客户端登录态: userid:', userID)
      if (userID !== '0') {
        await login()
      }
    })
  }
})

onMounted(() => {
  console.log('isLoginxxx', isLogin.value)
  if (!isLogin.value && !isInit) {
    isInit = true
    if (!isSeparateAccount) loginIframeFunc({}, route)
  }
})

onMounted(() => {
  loopLogin()
})

onUnmounted(() => {
  timer && clearInterval(timer)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper login-page", {'old-login': !_unref(isSeparateAccount)}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Carousel)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(isSeparateAccount))
              ? (_openBlock(), _createBlock(Login, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}
}

})